<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content class="cursor-pointer">
    <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="notification.counter" />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ notification.counter }} New</h3>
        <p class="opacity-75">App Notifications</p>
      </div>

      <VuePerfectScrollbar
        v-if="notification.rows.length"
       ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items">
          <li @click="directTo(ntf, index)" v-for="(ntf,index) in notification.rows" :key="index" class="flex justify-between px-4 py-4 notification cursor-pointer" :class="{'bg-grey-light': ntf.read === 'false' || ntf.read === false}">
            <div class="flex items-start">
              <div class="mx-2">
                <span class="fblock notification-title font-bold">{{ ntf.title }}</span> <br>
                <small>{{ truncate(ntf.body, 50) }}</small>
              </div>
            </div>
            <!-- <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(moment(ntf.timestamp)) }}</small> -->
          </li>
        </ul>
      </VuePerfectScrollbar>

      <div v-if="!notification.rows.length" class="text-center p-2">
        No Notifications
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import moment from 'moment'
import { truncate } from '@/utils/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapState } from 'vuex'

export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
      truncate,
      moment
    }
  },
  methods: {
    getNotification() {
      const getNotifications = this.$axios.get('notifications')
      const getCounterNotification = this.$axios.get('notifications/feed')

      Promise.all([getNotifications, getCounterNotification])
        .then(res => {
          const notifications = res[0].data.data
          const counter = res[1].data.data

          this.$store.commit('set_notification', {
            rows: notifications,
            counter
          })
        })
    },
    directTo(notification, index) {
      let {type, itemId, id, read} = notification
      let url = ''
      switch (type) {
        case 'BRAND_AMBASADOR':
        case 'BIRTH_DAY':
          url = 'brand-ambassador'
          break;
        case 'CAMPAIGN':
          url = 'campaign'
          break;
        case 'REDEEM':
        case 'GIVE_AWAY':
          url = 'product-claim'
          break;
        case 'WITHDRAW':
          url = 'withdraw'
          itemId = ''
          break;
        default:
          url = 'dashboard'
          itemId = ''
          break;
      }
      const fullUrl = `/${url}/${itemId}`
      this.$axios.get(`/notifications/${id}`).then(() => {
        const {rows, counter} = JSON.parse(JSON.stringify(this.notification))
        let setCounter = counter
        if(read !== 'true') {
          rows[index].read = "true"
          setCounter = counter > 0 ? counter - 1 : 0
        }
        this.$store.commit('set_notification', {
          rows: [...rows],
          counter: setCounter
        })
        if(fullUrl !== this.$route.path) {
          this.$router.push(fullUrl)
        }
      })
    },

    elapsedTime(startTime) {
      let x        = new Date(startTime)
      let now      = new Date()
      var timeDiff = now - x
      timeDiff    /= 1000

      var seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      var minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      var hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      var days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      var years   = timeDiff

      if (years > 0) {
        return years + (years > 1 ? ' Years ' : ' Year ') + 'ago'
      } else if (days > 0) {
        return days + (days > 1 ? ' Days ' : ' Day ') + 'ago'
      } else if (hours > 0) {
        return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago'
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago'
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now')
      }

      return 'Just Now'
    },
  },
  computed: {
    ...mapState(['notification'])
  },
  created() {
    this.getNotification()
  }
}

</script>

